/*
 * File: /src/router/routes/pipelines.js
 * Created Date: Monday August 17th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 18th August 2020 11:20:52 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const PipelineOverview = () =>
  import(
    /* webpackChunkName: "Pipeline" */ 'src/components/Dashboard/Views/Contacts/Companies/PipelineOverview.vue'
  );

//
export const pipelineRoutes = [
  {
    path: 'pipeline',
    name: 'Pipeline',
    component: PipelineOverview,
    props: (route) => ({
      filterLeadCategory: route.query.leadCategory
        ? parseInt(route.query.leadCategory)
        : undefined,
      filterLeadTypeId: route.query.leadType
        ? parseInt(route.query.leadType)
        : undefined,
      filterAgents: route.query.agents
        ? Array.isArray(route.query.agents)
          ? route.query.agents.map((id) => parseInt(id))
          : [parseInt(route.query.agents)]
        : [],
      filterFollowupToday: route.query.followupToday === 'true',
      filterDate:
        route.query.dateFrom && route.query.dateTo
          ? [new Date(route.query.dateFrom), new Date(route.query.dateTo)]
          : [],
      filterLeadProduct: route.query.product || undefined,
      filterTags: route.query.tags
        ? route.query.tags.split(',').map((id) => parseInt(id))
        : [],
      filterSearch: route.query.search || '',
      activeFilters: route.query.activeFilters
        ? route.query.activeFilters.split(',')
        : ['leadCategory', 'leadType'],
    }),
  },
];
